import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCodeTree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCodeTree"><Path d="M4.5 3V17.5H14.5" stroke="currentColor"/><Path d="M4.5 9.5H14.5" stroke="currentColor"/><Circle cx="17" cy="17.5" r="2.5" stroke="currentColor"/><Circle cx="17" cy="9.5" r="2.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconCodeTree;
